import { useQuery } from '@tanstack/react-query';
import { Badge, Card, LoadingBar, SupportingText } from 'corso-admin-ui';
import { match } from 'ts-pattern';
import api from '~/api';
import { useProduct } from '~/features/products/ProductProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export function ProductGroupMembership() {
  const { id } = useProduct();
  const storeId = useStoreId();

  // fetched apart from the product so the group rules never slow the main lookup
  const productGroupsQuery = useQuery({
    queryKey: ['product', id, 'groups', storeId],
    queryFn: () => api.store(storeId).product.groups(`${id}`),
  });

  return (
    <Card>
      <Card.Line>
        <Card.Heading>Product Groups</Card.Heading>
      </Card.Line>

      {match(productGroupsQuery)
        .with({ status: 'pending' }, () => <LoadingBar />)
        .with({ status: 'error' }, () => (
          <SupportingText error>
            Sorry, failed to load the product groups. Please refresh the page.
          </SupportingText>
        ))
        .with({ status: 'success', data: [] }, () => (
          <SupportingText>Not in any product groups.</SupportingText>
        ))
        .with({ status: 'success' }, ({ data: productGroups }) => (
          <div className="flex flex-wrap gap-1">
            {productGroups.map((group) => (
              <Badge key={group.id}>{group.name}</Badge>
            ))}
          </div>
        ))
        .exhaustive()}
    </Card>
  );
}
